export class OcorrenciaPedagioModel {

  IdPracaPedagio: number;
  IdTipoVeiculo: number;
  ValorAntigo: number;
  ValorNovo: number;
  Empresa: String;
  DataOcorrencia: String;
  Observacoes: String;
  
}